export enum CookiesConsentValue {
  YES = 'yes',
  NO = 'no'
}
